import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        label: {
            color: `${theme.palette.secondary[700]} !important`,
            fontSize: `${theme.typography.caption.fontSize}px !important`,
            lineHeight: '1.15 !important',
            whiteSpace: 'nowrap',
            paddingTop: theme.spacing(2),
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
        },
    }
})

export default useStyles
